import router from './router'

export default {
	moduleName: 'market',
	router
}



// WEBPACK FOOTER //
// ./src/core/modules/market/index.js